import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

const FallbackMessage = () => <FormattedMessage id="journeySegment.timetableNoInformation" />;

export default injectIntl(FallbackMessage);
